import React from "react";
import ReactDOM from "react-dom";
import App from "./App.jsx"; // Adjust the path if needed

ReactDOM.render(<App />, document.getElementById("root"));
